module.exports = __webpack_public_path__ + "img/soup.f0780bad.jpg";